import styled from "styled-components";
import { Grid } from "@material-ui/core";

interface IProps {
  isOtherApplication: boolean;
}

export const STGridButton = styled(Grid)`
  && {
    background-color: rgba(0, 0, 0, 0.14);
    height: 30px;
    text-align: center;
    font-size: 17px;
    :hover {
      cursor: pointer;
    }
  }
`;

export const STGrid = styled(Grid
)`&& {
  padding: 0;
  margin: 0;
  ${(props: any) =>
    props.isOtherApplication ? `height: calc(100vh - 30px)` : null};
`;

export const STGridOther = styled(Grid)`
  padding: 0;
  margin: 0;
`;
